import { ProfileListDefaults } from '../../types';

function getProfilePosition(pageNumber: number, activeIndex: number): number {
  return (
    (pageNumber - 1) * ProfileListDefaults.ItemsPerPage + (activeIndex + 1)
  );
}

export default getProfilePosition;
